import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { customersFormSchema } from './customers-form.schema';
import { useGetCustomerQuery } from 'api/user-domain/user-domain';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useQueryWithForm } from 'hooks/rtkq.hooks';

export const useEditCustomersForm = userId => {
  const queryResult = useGetCustomerQuery(userId ?? skipToken);

  const form = useForm({
    resolver: yupResolver(customersFormSchema),
    defaultValues: customersFormSchema.cast(queryResult?.data),
  });

  useQueryWithForm(form, queryResult, customersFormSchema);
  return { form, queryResult };
};
